
import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-orange-500 to-orange-600">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Make Your Event Unforgettable?
        </h2>
        <p className="text-xl text-white/90 mb-8">
          Book your overhead 360 video booth or signature photo booth today and give your guests 
          an experience they'll never forget.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="px-8 py-4 bg-white text-orange-500 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Get a Quote
          </Link>
          <Link
            to="/about"
            className="px-8 py-4 bg-orange-700 text-white rounded-lg font-semibold hover:bg-orange-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Learn More About Us
          </Link>
        </div>
      </div>
    </section>
  );
}
